module.exports = __webpack_public_path__ + "static/media/L5.184cb98b.jpg";